<label for="instock" class="text">{{ 'catalog.only-stock' | translate }} </label> <!--Alleen producten op voorraad-->
<div class="checkbox-toggle">
  <input type="checkbox" id="instock" [formControl]="checkbox"/>
  <label for="instock">
    toggle
  </label>
</div>

